import { render, staticRenderFns } from "./BackToTopButton.vue?vue&type=template&id=214f541a&scoped=true&"
import script from "./BackToTopButton.vue?vue&type=script&lang=js&"
export * from "./BackToTopButton.vue?vue&type=script&lang=js&"
import style0 from "./BackToTopButton.vue?vue&type=style&index=0&id=214f541a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214f541a",
  null
  
)

export default component.exports